import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { OperatorSchema } from './operator';
const c = initContract();
/** Mirrors the backend `PhonePlanView` (catalog domain). */
export const PhonePlanSchema = z.object({
    id: z.string(),
    name: z.string(),
    price: z.number(),
    customPrice: z.number().nullable(),
    isDataOnly: z.boolean(),
    dataLimitMo: z.number(),
    operator: OperatorSchema,
});
export const UpdatePhonePlanCustomPriceBodySchema = z.object({
    // Price in cents. `null` clears the custom price → the org falls back to
    // the plan's base price.
    customPrice: z.number().int().positive().nullable(),
});
export const UpdatePhonePlanBasePriceBodySchema = z.object({
    // Base (catalog) price in cents — global to every organization.
    price: z.number().int().positive(),
});
export const phonePlanContract = c.router({
    listPhonePlans: {
        method: 'GET',
        path: '/organizations/:organizationId/phone-plans',
        pathParams: z.object({ organizationId: z.string().min(1) }),
        query: z.object({
            operatorId: z.string().optional(),
            mobileLineType: z.enum(['classic', 'dataonly']).optional(),
            changeableFrom: z.string().optional(),
        }),
        responses: {
            200: z.array(PhonePlanSchema),
        },
        summary: 'List the phone plans available to an organization',
    },
    updatePhonePlanCustomPrice: {
        method: 'PATCH',
        path: '/organizations/:organizationId/phone-plans/:planId',
        pathParams: z.object({
            organizationId: z.string().min(1),
            planId: z.string().min(1),
        }),
        body: UpdatePhonePlanCustomPriceBodySchema,
        responses: {
            200: z.object({ success: z.literal(true) }),
        },
        summary: 'Set or clear the org-specific price of a plan',
    },
    updatePhonePlanBasePrice: {
        method: 'PATCH',
        path: '/admin/phone-plans/:planId',
        pathParams: z.object({ planId: z.string().min(1) }),
        body: UpdatePhonePlanBasePriceBodySchema,
        responses: {
            200: z.object({ success: z.literal(true) }),
        },
        summary: 'Set the base catalog price of a plan (admin)',
    },
});
